<template>
  <div style="margin-top: 20px; padding: 11px;">
    <div class="company-details-container">
      <div class="company-details-header">
        <h1>Sözleşme Bilgileri</h1>
        <span @click="toggleContractInfo" class="arrow-icon" :class="{'open': showContractInfo}">&#x25BC;</span>
        <hr>
      </div>

      <div v-if="showContractInfo">
        <div class="table-responsive">
          <table v-if="contractData">
            <thead>
            <tr>
              <th>Sözleşme Adı</th>
              <th>Sözleşme Numarası</th>
              <th>Firma Adı</th>
              <th>Sözleşme Süresi (Ay)</th>
              <th>Sözleşme Tarihi</th>
              <th>Yenileme Tarihi</th>
              <th>Toplam Sözleşme Bedeli</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ contractData.contractname }}</td>
              <td>{{ contractData.contractnumber }}</td>
              <td>{{ contractData.companyname }}</td>
              <td>{{ contractData.contracttime }} Ay</td>
              <td>{{ formatDate(contractData.contractdate) }}</td>
              <td>{{ formatDate(contractData.renewalcontractdate) }}</td>
              <td>{{ formatCurrency(contractData.contractprice) }}</td>
            </tr>
            </tbody>
          </table>
          <p v-else>Sözleşme bilgisi bulunamadı.</p>
        </div>
      </div>
    </div>

    <div class="company-details-container">
      <div class="company-details-header">
        <h1>Aktif Personel Bilgileri</h1>
        <span @click="togglePersonalInfo" class="arrow-icon" :class="{'open': showPersonalInfo}">&#x25BC;</span>
        <hr>
      </div>

      <div v-if="showPersonalInfo">
        <div class="table-responsive">
          <table v-if="personalExpenses && personalExpenses.length">
            <thead>
            <tr>
              <th>Personel Adı</th>
              <th>Personel Rolü</th>
              <th>Çalışma Saati</th>
              <th>Başlangıç Tarihi</th>
              <th>Bitiş Tarihi</th>
              <th>Durum</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="expense in personalExpenses"
                :key="expense.personalexpenseid"
                :class="{ 'expired-contract': isExpired(expense.personalenddate), 'future-termination': isFutureTermination(expense.personalenddate) }">
              <td>{{ expense.personalname }}</td>
              <td>{{ expense.personalrolename }}</td>
              <td>{{ expense.workedhours }} Saat</td>
              <td>{{ formatDate(expense.personalstartdate) }}</td>
              <td>{{ expense.personalenddate ? formatDate(expense.personalenddate) : 'Tarih Belirtilmemiştir' }}</td>
              <td>
                <span :class="getStatusClass(expense.personalenddate)">
                  {{ getStatusText(expense.personalenddate) }}
                </span>
              </td>
            </tr>
            </tbody>
          </table>
          <p v-else>Personel bilgisi bulunamadı.</p>
        </div>
      </div>
    </div>

    <div class="company-details-container">
      <div class="company-details-header">
        <h1>Pasif Personel Bilgileri</h1>
        <span @click="togglePassivePersonalInfo" class="arrow-icon" :class="{'open': showPassivePersonalInfo}">&#x25BC;</span>
        <hr>
      </div>

      <div v-if="showPassivePersonalInfo">
        <div class="table-responsive">
          <table v-if="passivePersonals && passivePersonals.length">
            <thead>
            <tr>
              <th>Personel Adı</th>
              <th>Personel Rolü</th>
              <th>Çalışma Saati</th>
              <th>Başlangıç Tarihi</th>
              <th>Bitiş Tarihi</th>
              <th>Pasif Olma Tarihi</th>
              <th>Durum</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="personal in passivePersonals"
                :key="personal.personalexpenseid"
                class="passive-personal">
              <td>{{ personal.personalname }}</td>
              <td>{{ personal.personalrolename }}</td>
              <td>{{ personal.workedhours }} Saat</td>
              <td>{{ formatDate(personal.personalstartdate) }}</td>
              <td>{{ formatDate(personal.personalenddate) }}</td>
              <td>{{ formatDate(personal.personaldeletedat) }}</td>
              <td>
                <span class="status-passive">İşten Çıkmış</span>
              </td>
            </tr>
            </tbody>
          </table>
          <p v-else>Pasif personel bulunmamaktadır.</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import apiClient from "@/axios";

export default {
  name: "contractDetails",
  data() {
    return {
      contractData: null,
      personalExpenses: [], // Yeni eklenen
      showPersonalInfo: false,
      showPassivePersonalInfo: false,
      showContractInfo: true,
      showFileInfo: false,
      passivePersonals: [],
    };
  },
  created() {
    this.getContractData();
    this.getPersonalExpenses();
    this.getPassivePersonals();
  },
  methods: {
    getPassivePersonals() {
      const contractId = this.$route.params.id;
      apiClient.get(`/personal-expenses/passive-contract/${contractId}`)
          .then((response) => {
            this.passivePersonals = response.data.filter(expense => {
              const hasPersonalId = expense.personalid !== null;
              const isPassive = expense.personaldeletedat !== null;
              return hasPersonalId && isPassive;
            });
            console.log('Pasif personel verileri:', this.passivePersonals);
          })
          .catch((error) => {
            console.error("Pasif personel verisi alınırken hata oluştu:", error);
            this.passivePersonals = [];
          });
    },
    isExpired(date) {
      if (!date) return false;
      const contractDate = new Date(date);
      const today = new Date();
      return contractDate < today;
    },
    isFutureTermination(date) {
      if (!date) return false;
      const contractDate = new Date(date);
      const today = new Date();
      return contractDate > today;
    },
    getStatusClass(date) {
      if (!date) return 'status-active';
      const contractDate = new Date(date);
      const today = new Date();
      if (contractDate < today) {
        return 'status-passive';
      } else if (contractDate > today) {
        return 'status-future';
      }
      return 'status-active';
    },
    getStatusText(date) {
      if (!date) return 'Aktif';
      const contractDate = new Date(date);
      const today = new Date();
      if (contractDate < today) {
        return 'İşten Çıkmış';
      } else if (contractDate > today) {
        return 'Gelecekte İşten Çıkacak';
      }
      return 'Aktif';
    },
    getPersonalExpenses() {
      const contractId = this.$route.params.id;
      apiClient.get(`personal-expenses/active-contract/${contractId}`).then((res) => {
        console.log('Active Personal Expenses:', res.data); // Gelen veriyi kontrol et
        // Filter out entries where personalid is null
        this.personalExpenses = res.data.filter(expense => expense.personalid !== null);
      }).catch((error) => {
        console.error("Aktif personel giderleri verisi alınırken hata oluştu:", error);
        this.personalExpenses = [];
      });
    },
    formatDate(timestamp) {
      if (!timestamp) return "-";
      return new Date(timestamp).toLocaleDateString("tr-TR");
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY"
      }).format(value);
    },
    getContractData() {
      const contractId = this.$route.params.id;
      apiClient.get(`contract/${contractId}`).then((res) => {
        this.contractData = res.data;
      }).catch((error) => {
        console.error("Sözleşme verisi alınırken hata oluştu:", error);
        this.contractData = {};
      });
    },
    togglePersonalInfo() {
      this.showPersonalInfo = !this.showPersonalInfo;
    },
    togglePassivePersonalInfo() {
      this.showPassivePersonalInfo = !this.showPassivePersonalInfo;
    },
    toggleContractInfo() {
      this.showContractInfo = !this.showContractInfo;
    },
    toggleFileInfo() {
      this.showFileInfo = !this.showFileInfo;
    },
  },
};
</script>


<style scoped>

.expired-contract {
  background-color: rgba(255, 0, 0, 0.1); /* Hafif kırmızı arka plan */
}

/* Opsiyonel: Hover efekti için */
.expired-contract:hover {
  background-color: rgba(255, 0, 0, 0.2);
}

.future-termination {
  background-color: rgba(255, 255, 0, 0.1); /* Hafif sarı arka plan */
}

/* Opsiyonel: Hover efekti için */
.future-termination:hover {
  background-color: rgba(255, 255, 0, 0.2);
}

.status-passive {
  color: #dc3545;
  font-weight: bold;
}

.status-active {
  color: #28a745;
  font-weight: bold;
}

.status-future {
  color: #ffc107;
  font-weight: bold;
}

.table-responsive {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.company-details-container {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.company-details-header {
  text-align: left;
  margin-bottom: 20px;
}

.company-details-header h1 {
  font-size: 24px;
  color: #333;
  display: inline-block;
}

.arrow-icon {
  float: right;
  cursor: pointer;
  font-size: 24px;
  transition: transform 0.2s ease;
  color: #3498db;
}

.arrow-icon.open {
  transform: rotate(180deg);
}

.info-item {
  margin-bottom: 15px;
  font-size: 16px;
  color: #555;
}

.info-item strong {
  color: #333;
}

.active-status {
  color: green;
  font-weight: bold;
}

.inactive-status {
  color: red;
  font-weight: bold;
}

@media (max-width: 768px) {
  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  th,
  td {
    font-size: 14px;
    padding: 6px;
  }
}
</style>
